module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-th.d14b0aa6.png";